import { useEffect, useState } from "react";

const useOpen = (trigger?: boolean) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const open = () => setIsOpen(true);
  const close = () => setIsOpen(false);
  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    setIsOpen(Boolean(trigger));
  }, [trigger]);

  return { isOpen, open, close, toggle };
};

export default useOpen;
